(function(){
'use strict';

/**
 * FIELSEN Contact System v2.2 — Shopify Native
 *
 * Uses Shopify's native {%- form 'contact' -%} processing.
 * Success is determined by Shopify's server-side form.posted_successfully? signal,
 * detected at init via the presence of a .fce-success div in the DOM.
 *
 * No external endpoint. No Turnstile. No fetch(). No Cloudflare Worker.
 * Shopify's own reCAPTCHA/spam protection is preserved.
 *
 * gerard@fielsen.com is never referenced here.
 */

var FCE = {

  ORDER_TYPES: ['order-delivery', 'returns-refunds'],
  PRODUCT_TYPES: ['product-question', 'product-recommendation'],

  // ID of the panel Shopify confirmed as successfully posted on this page load.
  // Set by detectServerSuccess() — only when form.posted_successfully? is true.
  confirmedSuccessPanel: null,

  init: function() {
    this.detectServerSuccess();
    this.bindRouteButtons();
    this.bindSubTypeSelect();
    this.bindCommercialModel();
    this.bindCharCount();
    this.injectHoneypot();
    this.bindValidation();
    this.bindSubmit();
    this.bindDuplicateSubmission();
  },

  // -------------------------------------------------------------------------
  // Server-side success detection
  //
  // Shopify renders form.posted_successfully? = true after a successful native
  // contact form POST. This causes a .fce-success div to appear in the HTML
  // inside the relevant .fce-form panel.
  //
  // We detect this at init, record which panel it is, auto-reveal it, populate
  // the reference span, and clean the URL.
  //
  // When the user navigates to a different category after seeing the success,
  // the .fce-success div is removed from the DOM so it cannot reappear as a
  // false positive on subsequent route-button clicks.
  // -------------------------------------------------------------------------
  detectServerSuccess: function() {
    var self = this;
    var successEl = document.querySelector('.fce-form .fce-success');
    if (!successEl) return;

    var panel = successEl.closest('.fce-form');
    if (!panel) return;

    self.confirmedSuccessPanel = panel.id;

    // Populate the reference span
    var refSpan = successEl.querySelector('.fce-ref');
    if (refSpan && !refSpan.textContent) {
      refSpan.textContent = self.generateRef();
    }

    // Reveal the confirmed-success panel
    document.querySelectorAll('.fce-form').forEach(function(f) {
      f.classList.remove('is-visible');
    });
    panel.classList.add('is-visible');
    setTimeout(function() {
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);

    // Mark the correct route button active
    document.querySelectorAll('.fce-route-btn').forEach(function(btn) {
      if (btn.getAttribute('data-target') === panel.id) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-expanded', 'true');
      }
    });

    // Clean stale Shopify success query param from URL
    if (window.history && window.history.replaceState) {
      var clean = window.location.pathname +
        (window.location.search
          ? window.location.search
              .replace(/[?&]contact%5Bposted_successfully%5D=true/g, '')
              .replace(/[?&]posted_successfully=true/g, '')
              .replace(/^&/, '?')
          : '');
      window.history.replaceState(null, '', clean || window.location.pathname);
    }
  },

  // -------------------------------------------------------------------------
  // Reference generation — internal tracking only, does NOT imply submission
  // -------------------------------------------------------------------------
  generateRef: function() {
    var now = new Date();
    var pad = function(n) { return (n < 10 ? '0' : '') + n; };
    return 'FIE-' + now.getFullYear() + pad(now.getMonth() + 1) + pad(now.getDate()) +
      '-' + pad(now.getHours()) + pad(now.getMinutes()) + pad(now.getSeconds()) +
      '-' + Math.floor(1000 + Math.random() * 9000);
  },

  // -------------------------------------------------------------------------
  // Route button binding
  // type="button" — never submits a form, never triggers success UI
  // -------------------------------------------------------------------------
  bindRouteButtons: function() {
    var self = this;
    var btns = document.querySelectorAll('.fce-route-btn');
    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var targetId = btn.getAttribute('data-target');

        // If navigating away from confirmed-success panel, destroy its .fce-success div
        // permanently so it cannot reappear as a false positive
        if (self.confirmedSuccessPanel && targetId !== self.confirmedSuccessPanel) {
          var successPanel = document.getElementById(self.confirmedSuccessPanel);
          if (successPanel) {
            var oldSuccess = successPanel.querySelector('.fce-success');
            if (oldSuccess) oldSuccess.parentNode.removeChild(oldSuccess);
          }
          self.confirmedSuccessPanel = null;
        }

        // Update button states
        btns.forEach(function(b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-expanded', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-expanded', 'true');

        // Hide all panels, reveal target
        document.querySelectorAll('.fce-form').forEach(function(f) {
          f.classList.remove('is-visible');
        });
        var panel = document.getElementById(targetId);
        if (panel) {
          panel.classList.add('is-visible');
          setTimeout(function() {
            panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 80);

          // Set enquiry_ref on first reveal (does NOT show success)
          var refInput = panel.querySelector('[name="contact[enquiry_ref]"]');
          if (refInput && !refInput.value) {
            refInput.value = self.generateRef();
          }
        }
      });
    });
  },

  // -------------------------------------------------------------------------
  // Customer Support sub-type → conditional fields
  // -------------------------------------------------------------------------
  bindSubTypeSelect: function() {
    var self = this;
    var sel = document.getElementById('fce-enquiry-type');
    if (!sel) return;
    sel.addEventListener('change', function() {
      var val = sel.value;
      var orderRow = document.getElementById('fce-cond-order');
      if (orderRow) {
        var showOrder = self.ORDER_TYPES.indexOf(val) >= 0;
        orderRow.classList.toggle('is-visible', showOrder);
        var inp = orderRow.querySelector('input');
        if (inp) inp.required = showOrder;
      }
      var prodRow = document.getElementById('fce-cond-product');
      if (prodRow) {
        prodRow.classList.toggle('is-visible', self.PRODUCT_TYPES.indexOf(val) >= 0);
      }
    });
  },

  // -------------------------------------------------------------------------
  // Commercial model "Other" → reveal explanation field
  // -------------------------------------------------------------------------
  bindCommercialModel: function() {
    var selects = document.querySelectorAll('.fce-commercial-model-select');
    selects.forEach(function(sel) {
      sel.addEventListener('change', function() {
        var frm = sel.closest('form');
        if (!frm) return;
        var otherRow = frm.querySelector('.fce-cond-other-model');
        if (otherRow) {
          var show = sel.value === 'Other';
          otherRow.classList.toggle('is-visible', show);
          var inp = otherRow.querySelector('input,textarea');
          if (inp) inp.required = show;
        }
      });
    });
  },

  // -------------------------------------------------------------------------
  // Character counters for data-min-chars textareas
  // -------------------------------------------------------------------------
  bindCharCount: function() {
    document.querySelectorAll('[data-min-chars]').forEach(function(el) {
      var min = parseInt(el.getAttribute('data-min-chars'), 10);
      var counter = document.createElement('span');
      counter.className = 'fce-char-count';
      counter.textContent = '0 / ' + min + ' min';
      counter.setAttribute('aria-live', 'polite');
      el.parentNode.appendChild(counter);
      el.addEventListener('input', function() {
        var len = el.value.length;
        counter.textContent = len + ' / ' + min + ' min';
        counter.classList.toggle('warn', len < min);
      });
    });
  },

  // -------------------------------------------------------------------------
  // Honeypot injection
  // -------------------------------------------------------------------------
  injectHoneypot: function() {
    document.querySelectorAll('.fce-form-inner').forEach(function(inner) {
      if (inner.querySelector('.fce-honeypot')) return;
      var hp = document.createElement('div');
      hp.className = 'fce-honeypot';
      hp.setAttribute('aria-hidden', 'true');
      hp.innerHTML = '<label>Leave blank<input type="text" name="contact[website_url_check]" tabindex="-1" autocomplete="off" value=""></label>';
      inner.appendChild(hp);
    });
  },

  // -------------------------------------------------------------------------
  // Field-level validation
  // -------------------------------------------------------------------------
  validateField: function(field) {
    var val = field.value.trim();
    var wrap = field.closest('.fce-field');
    var errEl = wrap ? wrap.querySelector('.fce-error-msg') : null;
    var ok = true;
    var msg = '';

    if (field.required && val === '') {
      ok = false; msg = 'This field is required.';
    } else if (field.type === 'email' && val) {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
        ok = false; msg = 'Please enter a valid email address.';
      }
    } else if (field.type === 'url' && val && field.required) {
      if (!/^https?:\/\/.+\..+/.test(val)) {
        ok = false; msg = 'Please enter a valid URL beginning with https://';
      }
    } else if (field.type === 'tel' && val) {
      if (!/^\+?[\d\s\-().]{6,}$/.test(val)) {
        ok = false; msg = 'Please enter a valid telephone number including country code (e.g. +44 ...)';
      }
    } else if (field.hasAttribute('data-min-chars') && val) {
      var min = parseInt(field.getAttribute('data-min-chars'), 10);
      if (val.length < min) {
        ok = false; msg = 'Please provide at least ' + min + ' characters.';
      }
    } else if (field.hasAttribute('data-min-chars') && !val && field.required) {
      ok = false; msg = 'This field is required.';
    }

    if (wrap) {
      wrap.classList.toggle('has-error', !ok);
      if (errEl) errEl.textContent = ok ? '' : msg;
    }
    return ok;
  },

  isFieldVisible: function(field) {
    var cond = field.closest('.fce-conditional');
    return !cond || cond.classList.contains('is-visible');
  },

  // -------------------------------------------------------------------------
  // Form-level validation (runs on submit)
  // -------------------------------------------------------------------------
  validateForm: function(form) {
    var self = this;
    var ok = true;

    // Honeypot — silently reject if filled
    var hp = form.querySelector('[name="contact[website_url_check]"]');
    if (hp && hp.value.trim() !== '') return false;

    form.querySelectorAll('input, select, textarea').forEach(function(f) {
      if (f.type === 'hidden' || f.type === 'submit' || f.type === 'checkbox') return;
      if (f.name === 'contact[website_url_check]') return;
      if (!self.isFieldVisible(f)) return;
      if (!self.validateField(f)) ok = false;
    });

    form.querySelectorAll('[data-required-check]').forEach(function(chk) {
      var wrap = chk.closest('.fce-field') || chk.closest('.fce-check-row');
      var errEl = wrap ? wrap.querySelector('.fce-error-msg') : null;
      if (!chk.checked) {
        ok = false;
        if (wrap) wrap.classList.add('has-error');
        if (errEl) errEl.textContent = 'You must acknowledge this to proceed.';
      } else {
        if (wrap) wrap.classList.remove('has-error');
        if (errEl) errEl.textContent = '';
      }
    });

    if (!ok) {
      var firstErr = form.querySelector('.has-error');
      if (firstErr) firstErr.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return ok;
  },

  // -------------------------------------------------------------------------
  // Blur-time validation
  // -------------------------------------------------------------------------
  bindValidation: function() {
    var self = this;
    document.querySelectorAll('.fce-form-inner input, .fce-form-inner select, .fce-form-inner textarea').forEach(function(f) {
      if (f.name === 'contact[website_url_check]') return;
      f.addEventListener('blur', function() { self.validateField(f); });
    });
  },

  // -------------------------------------------------------------------------
  // Submit — attaches to Shopify's native <form> elements.
  // Does NOT preventDefault on valid submissions — lets Shopify process them.
  // Only prevents submission when client-side validation fails.
  // -------------------------------------------------------------------------
  bindSubmit: function() {
    var self = this;
    document.querySelectorAll('.fce-form-inner').forEach(function(inner) {
      var form = inner.closest('form');
      if (!form || form._fceBound) return;
      form._fceBound = true;
      form.addEventListener('submit', function(e) {
        if (!self.validateForm(form)) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
        // Valid — allow Shopify native submission to proceed
        form.dataset.fceSubmitted = 'true';
      });
    });
  },

  // -------------------------------------------------------------------------
  // Prevent duplicate submission
  // -------------------------------------------------------------------------
  bindDuplicateSubmission: function() {
    document.querySelectorAll('.fce-submit-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var form = btn.closest('form');
        if (!form) return;
        setTimeout(function() {
          if (form.dataset.fceSubmitted === 'true') {
            btn.disabled = true;
            btn.textContent = 'Sending...';
          }
        }, 100);
      });
    });
  }

};

// Safe initialisation — handles both sync and async/deferred script loading
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { FCE.init(); });
} else {
  FCE.init();
}

})();
